import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public launchCount = 0;
  private readonly listener = new BehaviorSubject<boolean>(false);

  public subscribe(next: (x: boolean) => void): Subscription {
    return this.listener.subscribe(next);
  }

  public startLoad() {
    ++this.launchCount;
    this.listener.next(true);
  }

  public stopLoad(force?: boolean) {
    if (force) {
      this.launchCount = 0;
    } else {
      --this.launchCount;
      this.launchCount = this.launchCount < 0 ? 0 : this.launchCount;
    }
    if (this.launchCount === 0) {
      this.listener.next(false);
    }
  }
}
